import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class InstallAgentActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;
  protected canRunOnMultipleCompanies = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (record.specifics.serverHasNsxIntegration) {
      return false;
    }

    if (
      record.specifics.isSva ||
      record.specifics.isGhostr ||
      record.specifics.isNsva ||
      record.specifics.isSandboxAnalyzer
    ) {
      return false;
    }

    if (ProtectedEntitiesHelper.isComputer(record) && record.specifics.isManaged) {
      return ProtectedEntitiesHelper.isManagedByHviAndNotIsBest(record);
    }

    if (ProtectedEntitiesHelper.isCompanyFolderOrCompanyCollection(record)) {
      return false;
    }

    if (ProtectedEntitiesHelper.isAwsInstance(record) && ProtectedEntitiesHelper.isPowerStateTerminated(record)) {
      return false;
    }

    return true;
  }
}
